import { assertUnreachable } from '../util/index.js';
import * as db from './db.js';
export const toTuple = (property) => {
    const arr = property.split('.');
    return [arr[0], arr[1]];
};
export const fromTuple = (property) => {
    return `${property[0]}.${property[1]}`;
};
export const isIn = (property, values, path) => ({
    type: 'in',
    property: toTuple(property),
    values: values,
    path,
});
export const isNull = (property, path) => ({
    type: 'null',
    property: toTuple(property),
    path,
});
export const eq = (property, value, path) => ({
    type: 'eq',
    property: toTuple(property),
    value: value,
    path,
});
export const lt = (property, value, path) => ({
    type: 'lt',
    property: toTuple(property),
    value: value,
    path,
});
export const lte = (property, value, path) => ({
    type: 'lte',
    property: toTuple(property),
    value: value,
    path,
});
export const gt = (property, value, path) => ({
    type: 'gt',
    property: toTuple(property),
    value: value,
    path,
});
export const gte = (property, value, path) => ({
    type: 'gte',
    property: toTuple(property),
    value: value,
    path,
});
export const or = (...filters) => ({
    type: 'or',
    filters,
});
export const and = (...filters) => ({
    type: 'and',
    filters,
});
export const not = (filter) => ({ type: 'not', filter });
export const filterGuard = (filter, type, property) => {
    if (filter.type === 'and' || filter.type === 'or' || filter.type === 'not') {
        return filter.type === type;
    }
    return filter.type === type && fromTuple(filter.property) === property;
};
export const getFilterTables = (filter) => {
    if (filter == null) {
        return [];
    }
    switch (filter.type) {
        case 'and':
        case 'or': {
            return filter.filters.flatMap((filter) => {
                return getFilterTables(filter);
            });
        }
        case 'not': {
            return getFilterTables(filter.filter);
        }
        case 'eq':
        case 'gt':
        case 'gte':
        case 'in':
        case 'lt':
        case 'lte':
        case 'null': {
            return [filter.property[0]];
        }
    }
    return assertUnreachable(filter);
};
export const query = (base) => (q) => {
    return q;
};
export const getScopes = (query) => {
    let scopes = [];
    const visibleTables = Object.keys(query.properties);
    for (const table of visibleTables) {
        scopes.push(db.schema.entities[table].scope);
    }
    if (query.scoped) {
        for (const table of Object.keys(query.scoped)) {
            scopes.push(db.schema.entities[table].scope);
        }
    }
    const filterTables = [...new Set(getFilterTables(query.filters))];
    for (const table of filterTables) {
        scopes.push(db.schema.entities[table].scope);
    }
    return [...new Set(scopes)];
};
//# sourceMappingURL=index.js.map